// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__2TTRp","choiceBoxes":"toolbarselects_choiceBoxes__mGPkJ","simpleField":"toolbarselects_simpleField__YkfBl"};